import { SocialMediaItem } from './interfaces';

export const DEFAULT_SOCIAL_MEDIA_LIST: SocialMediaItem[] = [
  {
    icon: 'action/facebook',
    url: 'https://www.facebook.com/enercity',
  },
  {
    icon: 'action/instagram',
    url: 'https://www.instagram.com/enercity_ag',
  },
  {
    icon: 'user/mail',
    url: 'mailto:kundenservice@enercity.de',
    title: 'Mail schreiben',
  },
];
